<div class="ss-sync-bar-holder" *ngIf='!newRecorder'>
  <span class="ss-btn-sync sync-small"
    (mousedown)="startRepeat(-5)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(-5)" (touchend)="stopRepeat()">-</span>
  <span class="ss-btn-sync"
    (mousedown)="startRepeat(-20)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(-20)" (touchend)="stopRepeat()">-</span>
  <div class="sync-control">
    <div class="seeker-holder">
      <span class="ss-seeker ss-seeker-label" [style.left]="getProgress() + '%'"
        [style.visibility]="editing ? 'hidden' : 'visible'"
        (mousedown)="startEdit($event)">Voice {{getValue()}}</span>
      <input #editInput class="ss-seeker ss-seeker-input" [class.is-visible]="editing"
        [style.left]="getProgress() + '%'"
        [(ngModel)]="editValue"
        (blur)="commitEdit()"
        (keydown)="onEditKey($event)"
        type="number" />
      <span class="ss-seeker ss-seeker-music" [style.left]="'50%'">Music</span>
    </div>
    <input type="range" [ngClass]="getClasses()" [step]="step" [min]="min" [max]="max" [(ngModel)]="value"
      (change)="onSeek($event)" (input)="onSeek($event)" />
  </div>
  <span class="ss-btn-sync"
    (mousedown)="startRepeat(20)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(20)" (touchend)="stopRepeat()">+</span>
  <span class="ss-btn-sync sync-small"
    (mousedown)="startRepeat(5)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(5)" (touchend)="stopRepeat()">+</span>
</div>

<div class="ss-sync-bar-holder" *ngIf='newRecorder'>
  <span class="ss-btn-sync sync-small"
    (mousedown)="startRepeat(-5)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(-5)" (touchend)="stopRepeat()">-</span>
  <span class="ss-btn-sync"
    (mousedown)="startRepeat(-20)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(-20)" (touchend)="stopRepeat()">-</span>
  <div class="sync-control">
    <div class="seeker-holder">
      <span class="ss-seeker ss-seeker-label" [style.left]="getProgress() + '%'"
        [style.visibility]="editing ? 'hidden' : 'visible'"
        (mousedown)="startEdit($event)">Voice {{getValue()}}</span>
      <input #editInput class="ss-seeker ss-seeker-input" [class.is-visible]="editing"
        [style.left]="getProgress() + '%'"
        [(ngModel)]="editValue"
        (blur)="commitEdit()"
        (keydown)="onEditKey($event)"
        type="number" />
      <span class="ss-seeker ss-seeker-music" [style.left]="'50%'">Music</span>
    </div>
    <input type="range" [ngClass]="getClasses()" [step]="step" [min]="min" [max]="max" [(ngModel)]="value"
      (change)="onSeek($event)" (input)="onChange($event)" />
  </div>
  <span class="ss-btn-sync"
    (mousedown)="startRepeat(20)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(20)" (touchend)="stopRepeat()">+</span>
  <span class="ss-btn-sync sync-small"
    (mousedown)="startRepeat(5)" (mouseup)="stopRepeat()" (mouseleave)="stopRepeat()"
    (touchstart)="startRepeat(5)" (touchend)="stopRepeat()">+</span>
</div>
